import { render, staticRenderFns } from "./shopOrder.vue?vue&type=template&id=1cc7f3bc&scoped=true&"
import script from "./shopOrder.vue?vue&type=script&lang=js&"
export * from "./shopOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc7f3bc",
  null
  
)

export default component.exports